import { CircularProgress, Icon, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { useState, useEffect } from 'react';
import ArtApi from "../../api/ArtApi";
import { Link } from "react-router-dom";

import IUser from "../../models/Users/IUser";
import UserRole from "../../components/Users/UserRoleView";
import AddUser from "./AddUser";


export const AllUsers = () => {
    const [error, setError] = useState<string | null>(null);
    const [users, setUsers] = useState<IUser[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [limit] = useState(10);
    const [skip, setSkip] = useState(0);

    const nextPage = () => {
        setSkip(skip + limit);
    };

    const previousPage = () => {
        setSkip(skip - limit);
    };

    useEffect(() => {
        setIsLoading(true);
        ArtApi.getUsers(limit, skip)
            .then(response => {
                setUsers(response.response);
                setIsLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setIsLoading(false);
            });
    }, [skip, limit]);

    return (
        <Paper className="paper">
            <AddUser />
            <Table classes={{ root: "reactivetable" }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>E-Mail</TableCell>
                        <TableCell>Slack ID</TableCell>
                        <TableCell>Contact Preference</TableCell>
                        <TableCell>Roles</TableCell>
                        <TableCell>Edit</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user, i) => (
                        <TableRow key={i}>
                            <TableCell>
                                {user.name}
                            </TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.slackId}</TableCell>
                            <TableCell>{user.contactPreference}</TableCell>
                            <TableCell>
                                {user.roles.map((userRole, i) => (
                                    <UserRole key={i} role={userRole} />
                                ))}
                            </TableCell>

                            <TableCell>
                                <Link to={"user/" + user.userId}>
                                <Tooltip title="Edit User">
                                    <IconButton>
                                        <Icon>
                                            edit
                                    </Icon>
                                    </IconButton>
                                </Tooltip>
                            </Link>
                            </TableCell>
                        </TableRow>

                    ))}
                </TableBody>
            </Table>
            {isLoading && <CircularProgress color="secondary" />}
            {error}
            {skip !== 0 && (
                <IconButton onClick={previousPage}>
                    <Icon>arrow_back</Icon>
                </IconButton>
            )}
            {users.length !== 0 && limit === users.length && (
                <IconButton onClick={nextPage}>
                    <Icon>arrow_forward</Icon>
                </IconButton>
            )}
        </Paper>
    )
}